import { ApprovalStatus } from '../../models';

export function getApprovalStatus(foundStatus: ApprovalStatus, rowStatus: ApprovalStatus) {
    let status: ApprovalStatus;
    if (foundStatus === ApprovalStatus.Rejected || rowStatus === ApprovalStatus.Rejected) {
        status = ApprovalStatus.Rejected;
    } else if (foundStatus === ApprovalStatus.Waiting || rowStatus === ApprovalStatus.Waiting) {
        status = ApprovalStatus.Waiting;
    } else if (foundStatus === rowStatus) {
        // keep it that way
        status = foundStatus;
    } else {
        status = ApprovalStatus.WaitingForApproval;
    }
    return status;
}